export default async(handle: string) => {
  if (!handle) {
    return;
  }

  const _learnq = window['_learnq'] || [];
  const productResponse = await fetch(`/products/${handle}?view=klaviyo`);
  const productData = await productResponse.json();
  _learnq.push(['track', 'Added to Cart', productData]);
}
